import { NgModule } from '@angular/core';
import { NavigationEnd, Router, RouterModule, Routes } from '@angular/router';
import { AppService } from './app.service';
import { filter } from 'rxjs';
import { EmptyPageComponent } from './components/empty-page.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'welcome' },
  { path: ':page', component: EmptyPageComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {
  constructor(private appService: AppService, private router: Router) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        const currentPage = this.router.url.replace('/', '').toLowerCase();

        const pageIndex = this.appService.pages.findIndex(
          (p) =>
            p
              .toLowerCase()
              .replace(/\s+/g, '-')
              .replace(/[^\w-]/g, '') === currentPage
        );

        if (pageIndex !== -1) {
          this.appService.setPageIndex(pageIndex);
        }
      });
  }
}
